import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
let observer = null;
let currentDiscussionId = null;
let seenUuids = new Set();
let pendingUuids = new Set();
let observedElements = new WeakSet();
let countsByUuid = new Map();
function resetObserver() {
  if (observer) {
    observer.disconnect();
  }
  observer = null;
  currentDiscussionId = null;
  seenUuids = new Set();
  pendingUuids = new Set();
  observedElements = new WeakSet();
  countsByUuid = new Map();
}
function formatCount(count) {
  const n = Number(count) || 0;
  return n.toLocaleString('fr-FR') + (n > 1 ? ' vues' : ' vue');
}
function setImageCount(img, uuid, totalViews) {
  const link = img.closest('.FoFUpload--Upl-Image-Preview-Link');
  if (!link || !link.parentNode) {
    return;
  }
  let counter = link.nextElementSibling;
  if (!counter || !counter.classList.contains('val-image-view-count') || counter.getAttribute('data-val-image-uuid') !== uuid) {
    counter = document.createElement('span');
    counter.className = 'val-image-view-count';
    counter.setAttribute('data-val-image-uuid', uuid);
    counter.title = 'Nombre de vues';
    link.insertAdjacentElement('afterend', counter);
  }
  counter.textContent = formatCount(totalViews);
}
function updateAllOccurrences(uuid, totalViews) {
  countsByUuid.set(uuid, Number(totalViews) || 0);
  document.querySelectorAll('.FoFUpload--Upl-Image-Preview[data-id]').forEach(img => {
    if (img.getAttribute('data-id') === uuid) {
      setImageCount(img, uuid, totalViews);
    }
  });
}
function countView(element, uuid) {
  if (seenUuids.has(uuid) || pendingUuids.has(uuid)) {
    return;
  }
  pendingUuids.add(uuid);
  app.request({
    method: 'POST',
    url: `${app.forum.attribute('apiUrl')}/val/ui/image-view`,
    body: {
      uuid
    }
  }).then(result => {
    pendingUuids.delete(uuid);
    seenUuids.add(uuid);
    document.querySelectorAll('.FoFUpload--Upl-Image-Preview[data-id]').forEach(img => {
      if (img.getAttribute('data-id') === uuid && observer) {
        observer.unobserve(img);
      }
    });
    if (result && typeof result.total_views !== 'undefined') {
      updateAllOccurrences(uuid, result.total_views);
    }
  }).catch(() => {
    /*
     * Pas d'alerte utilisateur pour un simple compteur.
     * L'image reste observable et pourra être retentée
     * lors d'une nouvelle entrée dans la zone visible.
     */
    pendingUuids.delete(uuid);
  });
}
function createObserver() {
  return new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return;
      }
      const element = entry.target;
      const uuid = element.getAttribute('data-id');
      if (!uuid) {
        return;
      }
      countView(element, uuid);
    });
  }, {
    root: null,
    rootMargin: '-20% 0px -20% 0px',
    threshold: 0
  });
}
function observeImages(page) {
  const discussion = page && page.discussion;
  if (!discussion || typeof discussion.id !== 'function') {
    return;
  }
  const discussionId = String(discussion.id());
  if (discussionId !== currentDiscussionId || !observer) {
    resetObserver();
    currentDiscussionId = discussionId;
    observer = createObserver();
  }
  document.querySelectorAll('.FoFUpload--Upl-Image-Preview[data-id]').forEach(element => {
    const uuid = element.getAttribute('data-id');
    if (!uuid) {
      return;
    }
    if (countsByUuid.has(uuid)) {
      setImageCount(element, uuid, countsByUuid.get(uuid));
    }
    if (seenUuids.has(uuid) || observedElements.has(element)) {
      return;
    }
    observedElements.add(element);
    observer.observe(element);
  });
}
function scheduleObservation(page) {
  window.setTimeout(() => {
    observeImages(page);
  }, 0);
}
app.initializers.add('val-ui-image-views', () => {
  extend(DiscussionPage.prototype, 'oncreate', function () {
    scheduleObservation(this);
  });
  extend(DiscussionPage.prototype, 'onupdate', function () {
    scheduleObservation(this);
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    resetObserver();
  });
});